// extracted by mini-css-extract-plugin
export default {"content":"EventCard_content__HutIQ","details":"EventCard_details__tHyUA"};